export default "__VITE_ASSET__b7a83527__"